import { Button, Icon, Modal } from '@scuf/common';

import './DeleteAlertModal.scss';
import i18next from 'i18next';

interface IDeleteAlertModal {
  onClose: () => void;
  onConfirm: () => void;
  displayName: string;
  isLoadingDeleteUser: boolean;
}
export const DeleteAlertModal = (props: IDeleteAlertModal) => {
  return (
    <div className="delete-confirmation-modal">
      <Modal
        size="small"
        onClose={props.onClose}
        open={true}
        closeOnDocumentClick={false}
      >
        <br />
        <Modal.Header>
            <div className="title">{i18next.t('Alert')}</div>
            <Icon root="common" name="close" className="close-icon" onClick={props.onClose} />
        </Modal.Header>
        <Modal.Content>
          <div className="desc">{i18next.t('deleteModalAlertMessage', {
              userName: props.displayName
            })}
            <br />
            {i18next.t('deleteProceedMessage')}
            </div>
        </Modal.Content>
        <Modal.Footer>
          <Button
            type="secondary"
            size="medium"
            content={i18next.t('Confirm')}
            onClick={props.onConfirm}
            loading={props.isLoadingDeleteUser}
          />
          <Button
            type="primary"
            size="medium"
            content={i18next.t('Close')}
            onClick={props.onClose}
          />

        </Modal.Footer>
      </Modal>
    </div>
  );
};